module.exports = __webpack_public_path__ + "static/media/geofence.764eea65.svg";